module.exports = __webpack_public_path__ + "static/media/logo_agit.b7ba5f3a.png";